import React from 'react';
import { UploadImage } from "../../assets/imageAssets";
import { ArrowUpRight } from '@untitledui/icons/ArrowUpRight';

const UploadCard = ({onClick, disabled}) => {
    return (
        <button className={`upload-card${disabled ? ' upload-card--disabled' : ''}`} onClick={!disabled ? onClick : undefined} disabled={disabled}>
            <div className="upload-image">
                <img src={UploadImage} alt={'Upload & Generate'} />
            </div>
            <div className="upload-title">
                <div className="icon">
                    <ArrowUpRight size={24} />
                </div>
                <h6 className='mb-8'>Upload & Generate</h6>
                <p>Upload a file to generate a quiz instantly</p>
            </div>
        </button>
    );
}

export default UploadCard;